import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'; // Updated import
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable()
export class ComplianceMasterService {

    constructor(private http: HttpClient, private httpService: HttpService) {}

    getComplianceItemList() {
        var request = {
            URL: 'complianceItem/getComplianceItems'
        }
        return this.httpService.get(request);
    }

    addComplianceItem(complianceItem) {
        var request = {
            URL: 'complianceItem/addComplianceItem',
            DATA: complianceItem
        }
        return this.httpService.post(request);
    }

    getComplianceItemById(id: string) {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('x-access-token', localStorage.getItem('token') || '');
        return this.http.get(environment.pssServerUrl + 'complianceItem/getComplianceItemById/' + id, { headers: headers });
    }

    deleteComplianceItem(id) {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('x-access-token', localStorage.getItem('token') || '');
        return this.http.get(environment.pssServerUrl + 'complianceItem/removeComplianceItem/' + id, { headers: headers });
    }

    updateComplianceItem(complianceItem, id) {
        var request = {
            URL: 'complianceItem/updateComplianceItem/' + id,
            DATA: complianceItem
        }
        return this.httpService.post(request);
    }

    getPeriodicityData() {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('x-access-token', localStorage.getItem('token') || '');
        return this.http.get(environment.pssServerUrl + 'complianceItem/getPeriodicity', { headers: headers });
    }

    addComplianceCertificate(object) {
        var request = {
            URL: 'complianceItem/addComplianceCertificate',
            DATA: object
        }
        return this.httpService.post(request);
    }

    getComplianceCertificate(searchParam) {
        var request = {
            URL: 'complianceItem/getComplianceCertificate',
            DATA: searchParam
        }
        return this.httpService.post(request);
    }

    deleteComplianceCertificate(id) {
        var request = {
            URL: 'complianceItem/deleteComplianceCertificate/' + id
        }
        return this.httpService.get(request);
    }

    getComplianceCertificateById(id) {
        var request = {
            URL: 'complianceItem/getComplianceCertificateById/' + id
        }
        return this.httpService.get(request);
    }

    updateComplianceCertificate(object, id) {
        var request = {
            URL: 'complianceItem/updateComplianceCertificate/' + id,
            DATA: object
        }
        return this.httpService.post(request);
    }

    getMasterActivatedComplianceCertificate(searchParam) {
        var request = {
            URL: 'complianceItem/getActivatedMasterCertificate',
            DATA: searchParam
        }
        return this.httpService.post(request);
    }

    getActivatedComplianceCertificateByMasterId(id) {
        var request = {
            URL: 'complianceItem/getActivatedCertificatesByMasterId/' + id
        }
        return this.httpService.get(request);
    }

    getActivatedComplianceCertificateById(id) {
        var request = {
            URL: 'complianceItem/getActivatedComplianceCertificateById/' + id
        }
        return this.httpService.get(request);
    }

    updateActivatedComplianceCertificate(object, id) {
        var request = {
            URL: 'complianceItem/updateActivatedComplianceCertificate/' + id,
            DATA: object
        }
        return this.httpService.post(request);
    }

    activateMultipleCertificates(data) {
        var request = {
            URL: 'complianceItem/activateMultipleCertificates',
            DATA: data
        }
        return this.httpService.post(request);
    }
}
